
export default {
    name: 'AppBar',
    props: {
        displayMode: String,
    },
    data() {
        return {}
    },
    methods: {
        isDispaly() {
            if (this.displayMode === 'always') {
                return true
            } else {
                return this.$isShowAppBar();
            }
        }
    }
}
